var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-search-page-custom"},[(_vm.title)?_c('h1',{staticClass:"sr-only",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('LimboSearch',{staticClass:"pt-40 >=768:pt-80 relative",attrs:{"search-filters":_vm.filters,"extra-parameters":{
			searchId: _vm.searchId,
			pageId: _vm.pageId,
			url: _vm.url,
		},"config":{
			enableLiveSearch: true,
			enableGroupedSearch: true,
			allowSearchFiltersMutation: true,
			hiddenParameters: [
				'searchId',
				'pageId',
				'url',
				'siteId',
				'cultureId',
			],
			searchResponseTransformerMethod: _vm.searchResponseTransformerMethod,
			dataMergerMethod: _vm.dataMergerMethod,
			limit: {
				1: { initial: 3, value: 6 },
				2: { initial: 3, value: 6 },
				3: { initial: 3, value: 6 },
				10: { initial: 3, value: 6 },
			},
		}},on:{"update":_vm.onUpdate},scopedSlots:_vm._u([{key:"default",fn:function({ action, state }){return [_c('Transition',{attrs:{"name":"t-search-page-custom__flares"}},[(_vm.formattedGroups.length && _vm.onSearchPage)?_c('div',{class:[
					'h-full overflow-hidden pointer-events-none',
					'absolute top-0 -left-layout-margin -right-layout-margin',
				]},[_c('LensFlare',{class:[
						'c-search-page-custom__lensflare',
						'absolute top-0 max-w-layout-max w-full',
					],attrs:{"id":"search-flare-01","angle":45,"flares":[
						{
							size: 1000,
							offset: -200,
							theme: 'primary',
							opacity: 1,
						},
						{
							size: 450,
							offset: 200,
							theme: 'secondary',
							opacity: 0.8,
						},
					]}}),_vm._v(" "),(!state.isLoading)?_c('LensFlare',{class:[
						'c-search-page-custom__lensflare',
						'absolute bottom-0 max-w-layout-max w-full',
					],attrs:{"id":"search-flare-02","angle":225,"flares":[
						{
							size: 1000,
							offset: -200,
							theme: 'primary',
							opacity: 1,
						},
						{
							size: 450,
							offset: 200,
							theme: 'secondary',
							opacity: 0.8,
						},
					]}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('TransitionExt',{attrs:{"name":"fade-in-out","duration":"300"}},[(state.isLoading && state.isInitiated)?_c('div',{staticClass:"absolute top-0 left-0 w-full h-full"},[_c('LoaderGraphic',{class:[
						'sticky top-1/2 mx-auto z-50',
						'transform -translate-y-1/2',
					]})],1):_vm._e()]),_vm._v(" "),_c('Transition',{attrs:{"name":"t-search-page-custom__groups","mode":"out-in","appear":""}},[_c('div',{key:_vm.key,class:[
					'flex flex-col gap-y-3xl >=1024:gap-y-4xl',
					'pt-4xl pb-120 >=768:pb-220',
				]},[_vm._l((_vm.formattedInfoboxes),function(infobox,index){return _c('div',{key:`infobox-${index}`,class:[
						'flex flex-wrap justify-center gap-layout-gutter',
					]},_vm._l((infobox),function(section,sindex){return _c('div',{key:`infobox-section-${sindex}`,class:[
							'border-2 border-opacity-20 border-text',
							'font-darker-grotesque text-search-infobox font-medium',
							'w-full px-xl pt-xl pb-2xl',
							'>=1024:w-6/12col >=1024:px-3xl >=1024:py-xl',
						],domProps:{"innerHTML":_vm._s(section.text)}})}),0)}),_vm._v(" "),_vm._l((_vm.formattedGroups),function(group,gindex){return _c('div',{key:`group-${gindex}`},[_c('BaseH3',{staticClass:"mb-lg",attrs:{"tag":"h2"}},[_c('span',{staticClass:"mr-6",domProps:{"textContent":_vm._s(group.name)}}),_vm._v(" "),_c('span',{staticClass:"opacity-70",domProps:{"textContent":_vm._s(group.total)}})]),_vm._v(" "),(_vm.getComponentFromType(group.type))?_c(_vm.getComponentFromType(group.type),{tag:"Component",attrs:{"id":group.targetId,"items":group.items}}):_vm._e(),_vm._v(" "),(group.limit + group.offset < group.total)?_c('button',{class:[
							'mx-auto max-w-fit flex items-center gap-x-12 mt-lg',
							'uppercase font-darker-grotesque font-bold text-button-xs',
						],on:{"click":() => action.fetchMore(group.id)}},[_c('span',{domProps:{"textContent":_vm._s('Vis flere')}}),_vm._v(" "),_c('SvgIconCaret',{staticClass:"w-14 mt-3"})],1):_vm._e()],1)}),_vm._v(" "),_c('TransitionExt',{attrs:{"name":"fade-in-out","duration":"500"}},[(
							_vm.formattedGroups &&
							!_vm.formattedGroups.length &&
							_vm.computedFields.text &&
							_vm.computedFields.text.value.length &&
							!state.isLoading &&
							!_vm.formattedInfoboxes.length
						)?_c('div',{class:[
							'font-darker-grotesque font-medium',
							'text-h4 text-center',
						]},[_c('span',{domProps:{"textContent":_vm._s('Ingen resultater fundet')}})]):_vm._e()])],2)])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }